// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const aiProcessPatchMaxOutputTokensOneMin = 256;
export const aiProcessPatchMaxOutputTokensOneMax = 200000;

export const aiProcessPatchModelKeyOneMax = 120;

export const AiProcessPatch = zod.object({
  "max_output_tokens": zod.union([zod.int().min(aiProcessPatchMaxOutputTokensOneMin).max(aiProcessPatchMaxOutputTokensOneMax),zod.null()]).optional(),
  "model_key": zod.union([zod.string().max(aiProcessPatchModelKeyOneMax),zod.null()]).optional()
});

export type AiProcessPatch = zod.input<typeof AiProcessPatch>;
export type AiProcessPatchOutput = zod.output<typeof AiProcessPatch>;
